export default __webpack_public_path__ + "static/media/icon_doorsign.e6ba3ca7.svg";